export const ASSOCIATION_MODES = {
  CATEGORY: "CATEGORY",
  NARRATIVE: "NARRATIVE",
  FILTER: "FILTER",
};

export const SHAPE = "SHAPE";

export const DEFAULT_TAB_ICONS = {
  CATEGORY: "widgets",
  NARRATIVE: "timeline",
  FILTER: "filter_list",
  SHAPE: "change_history",
};

export const AVAILABLE_SHAPES = {
  STAR: "STAR",
  DIAMOND: "DIAMOND",
  PENTAGON: "PENTAGON",
  SQUARE: "SQUARE",
  DOT: "DOT",
  BAR: "BAR",
  TRIANGLE: "TRIANGLE",
};

export const POLYGON_CLIP_PATH = {
  STAR: "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
  DIAMOND: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)",
  PENTAGON: "polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)",
  TRIANGLE: "polygon(50% 0%, 0% 100%, 100% 100%)",
};

export const DEFAULT_CHECKBOX_COLOR = "#ffffff";
